import { CircularProgress, Dialog } from '@mui/material';

export function Spinner(props: { isActive: boolean }) {
  const { isActive } = props;

  return (
    <Dialog
      slotProps={{
        backdrop: {
          sx: {
            backgroundColor: 'transparent',
            backdropFilter: 'blur(2px)',
          },
        },
        paper: {
          sx: {
            width: 'auto',
            overflow: 'hidden',
            background: 'none',
            boxShadow: 'none',
          },
        },
      }}
      fullWidth
      open={isActive}
    >
      <CircularProgress size="120px" color="primary" />
    </Dialog>
  );
}
